import { InputField } from 'components/ui/InputField';
import Button from 'components/ui/Button';
import { useAppContext } from 'context/useAppContext';
import { formatAmountWithCommas } from 'utils/helpers';

const CustomerDetailsForm = () => {
  const { formData, nextStep } = useAppContext();

  return (
    <section className="px-2 md:px-6 h-full overflow-y-auto pb-6">
      <h2 className="font-grotesk font-semibold text-xl">Customer Details</h2>
      <div className="my-3 grid gap-4">
        <InputField
          name="firstName"
          value={formData.firstName}
          label="First name"
          disabled
          readonly
        />
        <InputField
          name="lastName"
          value={formData.lastName}
          label="Last name"
          disabled
          readonly
        />
        <InputField
          name="dateOfBirth"
          value={formData.dateOfBirth}
          label="Date of Birth"
          disabled
          readonly
        />
        <InputField
          name="emailAddress"
          value={formData.emailAddress}
          label="Email address"
          disabled
          readonly
        />
        <InputField
          name="gender"
          value={formData.gender}
          label="Gender"
          disabled
          readonly
        />
        <InputField
          name="phoneNumber"
          value={formData.phoneNumber}
          label="Phone number"
          disabled
          readonly
        />
        <InputField
          name="ticketPrice"
          value={`₦${formatAmountWithCommas(formData.ticketPrice)}`}
          label="Ticket Price"
          disabled
          readonly
        />
        <InputField
          name="bookingRef"
          value={formData.bookingRef}
          label="Booking ref"
          disabled
          readonly
        />
      </div>
      <div className="w-full mt-8">
        <Button
          onClick={nextStep}
          className="w-full !font-grotesk !font-medium !text-lg md:!text-xl"
        >
          Next
        </Button>
      </div>
    </section>
  );
};

export default CustomerDetailsForm;
